module.exports = __webpack_public_path__ + "img/hotel-leziria-parque.68a5857e.jpg";